export enum WaitlistNumbers {
  Zero = 0,
  Fifty = 50,
  Hundred = 100,
  OneHundredAndFifty = 150,
  TwoHundred = 200,
}
